import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';

export interface IFormRowProps {
    /** Label to display */
    label?: React.ReactNode;
    /** Error to display */
    error?: React.ReactNode;
    /** Description text to display */
    description?: React.ReactNode;
    /** Display text value instead of children */
    value?: React.ReactNode;
    /** Mark row as required */
    required?: boolean;
    /** Place asterisk to label */
    requiredPosition?: 'label';
    /** Highlight as important */
    important?: boolean;
}

interface IState {
}

/**
 * Single form row
 */
export default class FormRow extends React.Component<IFormRowProps, IState> {
    static displayName: string = 'FormRow';

    constructor (props: IFormRowProps) {
        super(props);
    }

    render () {
        return (
            <div className={classNames('form-row', {
                'has-error': this.props.error,
                'has-value': this.props.value,
                'is-important': this.props.important,
            })}>
                {!!this.props.label && (
                    <label className="form-row-label">
                        {this.props.required && this.props.requiredPosition === 'label' && (
                            <span className="form-row-required notranslate" translate="no">*</span>
                        )}
                        {this.props.label}
                    </label>
                )}
                <div className="form-row-main">
                    {this.props.required && this.props.requiredPosition !== 'label' && (
                        <span className="form-row-required notranslate" translate="no">*</span>
                    )}
                    <div className="form-row-items">
                        {this.props.value !== undefined ? (
                            <div className="form-row-value">{this.props.value ? this.props.value : '-'}</div>
                        ) : (
                            this.props.children
                        )}
                    </div>
                    {((!!this.props.error && typeof this.props.error !== 'boolean') || !!this.props.description) && (
                        <div className="form-row-sub">
                            {this.props.error && (
                                <div className="form-row-error">{this.props.error}</div>
                            )}
                            {this.props.description && (
                                <div className="form-row-description">{this.props.description}</div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
